module.exports = __webpack_public_path__ + "static/media/ro_close_up.170c30f8.jpg";